<script>
    import { sgettext } from '../../../i18n';
    import { get } from '../../../utils.js';
    import { PATH_PREFIX } from '../../../apiUrls.js';
    import { activityVersionId } from '../diffStore.js';

    import InstructionsPdfTemplateD2View from '../../Activity/InstructionsPDFTemplate/InstructionsPDFTemplateD2View.svelte';
    import Modal from '../../Modal.svelte';
    import Button from '../../Button.svelte';
    import Errors from '../../Errors.svelte';

    let d2DocumentMetadata = [];
    let activeLink = ''; 
    let isLoading = false;
    let errors = null;

    async function getDocumentMetadata() {
        isLoading = true;
        const response = await get(`${PATH_PREFIX}/sw/instruction/d2/view-document-metadata/?activity_version_id=${$activityVersionId}`);
        let json = await response.json();
        if(json.error) { errors = json.error; }
        d2DocumentMetadata = json;
        isLoading = false;
    }

    function showDocumentMetadataDialog() {
        activeLink = 'metadata';
        jQuery('#documentMetadataModal').modal('show');
        getDocumentMetadata();
    }

    function cancelDocumentMetadataModal() {
        activeLink = '';
        jQuery(`#documentMetadataModal`).modal('hide');
    }

</script>

<a
  class="nav-link"
  class:active={activeLink === 'metadata'}
  on:click={showDocumentMetadataDialog}
  href="#d2Metadata"
>
  <svg
    class="nav-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M8.6275 1.75L12.25 5.3725V12.25H1.75V1.75H8.6275ZM8.6275 0.25H1.75C0.925 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V5.3725C13.75 4.975 13.5925 4.5925 13.3075 4.315L9.685 0.6925C9.4075 0.4075 9.025 0.25 8.6275 0.25ZM3.25 9.25H10.75V10.75H3.25V9.25ZM3.25 6.25H10.75V7.75H3.25V6.25ZM3.25 3.25H8.5V4.75H3.25V3.25Z"
    />
  </svg>
  {sgettext('$$VIEW_DOCUMENT_METADATA$$')}
</a>

<Modal
  id="documentMetadataModal"
  title={sgettext('$$DOCUMENTUM_DOCUMENT_DETAILS$$')}
  onCancel={cancelDocumentMetadataModal}
>
  <div slot="body">
    {#if isLoading}
      <div class="text-center">
        <i class="fas fa-spinner fa-spin" />
      </div>
    {:else if !d2DocumentMetadata.error}
      <InstructionsPdfTemplateD2View {d2DocumentMetadata} />
    {:else}
      <Errors {errors} />
    {/if}
  </div>

  <div slot="footer">
    <Button
      name={sgettext('$$CLOSE$$')}
      on:click={cancelDocumentMetadataModal}
      type="secondary"
    />
  </div>
</Modal>

<style>
  .nav-link {
    text-decoration: none;
    background-color: transparent;
    color: grey;
    transition: background-color 0.3s, color 0.3s;
    display: flex;
    align-items: center;
    padding: 5px 10px;
  }

  .nav-link:hover {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .nav-link.active {
    color: #df5900;
    font-weight: 700;
  }

  .nav-icon {
    margin-right: 6px;
  }
</style>
